import React from "react";
import useController from "./controller";
import PageLoading from "../../components/ElementLoading";

interface Props {
  token: string;
}

export default function PageLoginToken({ token }: Props) {
  const { loading } = useController(token);
  return <PageLoading loading={loading} />;
}
